import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import {
  IParentSize, IState
} from "../../../types";
import { useAsyncFetch } from "../../../system/useFetch";
import { ISystemInformation } from "./types";
import HostStatus from "./hostStatus";
import "./styles.css";
import { IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import TabPanel from "../../../components/tabPanel";
import { useSelector } from "react-redux";
import ProcessesComponent from "./processesComponent";
import RefreshIcon from "@mui/icons-material/Refresh";

const fiveMinutes = 300000;

interface IProps {
  parentSize: IParentSize;
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};


const SystemInfoComponent = ({ parentSize }: IProps): ReactElement => {
  const [ getSystemInformation, { data: systemInformation } ] = useAsyncFetch<ISystemInformation>();
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [tabSelected, setTabSelected] = useState(0);
  const [ update, setUpdate ] = useState(0);

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  useEffect(() => {
    getSystemInformation({
      module: "sysMonitor",
      query: "getSystemInformation",
      payload: null
    }).then();

    const timer = setInterval(() => {
      getSystemInformation({
        module: "sysMonitor",
        query: "getSystemInformation",
        payload: null
      }).then();
    }, fiveMinutes);


    return () => {
      clearInterval(timer);
    };
  }, [ update ]);

  return (
    <>
      <div className="w-100 display-grid" style={{
        background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)",
        gridTemplateColumns: "36px 1fr 36px",
        justifyItems: "center"
      }} >
        <Tooltip title="Reset">
          <IconButton color="primary" onClick={() => setUpdate(prevState => ++prevState)} >
            <RefreshIcon/>
          </IconButton>
        </Tooltip>
        <Tabs
          value={tabSelected}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered={true}
          style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
          <Tab label="Host" {...a11yProps(0)} />
          <Tab label="Processes" {...a11yProps(1)} />
        </Tabs>
      </div>
      <TabPanel value={tabSelected} index={0}>
        <div className="display-flex-column gap-1" style={{ ...parentSize, maxHeight: parentSize.height - 50, overflowY: "auto" }}>
          {systemInformation && systemInformation.hosts.map((status) => <HostStatus status={status} key={status.code}/>)}
        </div>
      </TabPanel>
      <TabPanel value={tabSelected} index={1}>
        <div className="display-flex-column gap-1" style={{ ...parentSize, maxHeight: parentSize.height - 50, overflowY: "auto" }}>
          {systemInformation && <ProcessesComponent processes={systemInformation.processes} />}
        </div>
      </TabPanel>
    </>
  );
};


export default SystemInfoComponent;